import {
  Button,
  ButtonsWrapper,
  Form,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';

import { useRouteQuery } from 'src/common/helpers';
import { usePartialEmployeeUpdate } from 'src/hooks/employees/partial-employee-update.hook';
import { EducationsAndSkills } from 'src/pages/employee/sub-pages/create-employee/components/educations-and-skills';
import { IEducationsAndSkills } from 'src/components/employee/employee.interfaces';

const EducationsAndSkillsEdit = ({
  onCancel,
  initialValues,
}: {
  onCancel: () => void;
  initialValues: IEducationsAndSkills;
}) => {
  const { t } = useTranslation(['common', 'employee']);

  const query = useRouteQuery();
  const _id: string = query.get('id') || '';

  const partialEmployeeUpdate = usePartialEmployeeUpdate({ onSuccess: onCancel });

  const onFinish = (values: any) => {
    partialEmployeeUpdate({
      variables: {
        payload: {
          _id: _id,
          ...values,
        },
      },
    });
  };

  return (
    <div>
      <br />
      <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
        {t('employee:educationsAndSkills.labels.headerTitle')}
      </Typography>

      <Form
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ educationAndSkills: initialValues }}
      >
        <EducationsAndSkills isEdit />
        <ButtonsWrapper>
          <Button type="primary" htmlType="submit">
            {t('common:buttons.save')}
          </Button>
          <Button onClick={onCancel}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </div>
  );
};

export default EducationsAndSkillsEdit;
